import { isValid, format } from 'date-fns';

export const getDayAsString = (date: Date): string => {
    if (!isValid(date)) {
        return '';
    }

    return format(date, 'EEEE');
};

export const getTimeAsString = (date: Date, timeFormat = 'h:mm bb'): string => {
    if (!isValid(date)) {
        return '';
    }

    return format(date, timeFormat);
};
